<div
    class="grid card"
    style="margin: 0.45rem"
    xmlns="http://www.w3.org/1999/html"
>
    <div class="col-12">
        <form [formGroup]="quotationsForm">
            <div>
                <div class="flex align-items-start gap-3">
                    <img
                        class="title-image"
                        src="../../../../assets/demo/images/shield.gif"
                    />
                    <div class="flex flex-column pt-1">
                        <h4 class="mb-0 pb-0">
                            {{ "Get A Quote" | translate }}
                        </h4>
                        <small class="list-stats">
                            {{ "Fill in the form" | translate }}</small
                        >
                    </div>
                </div>
                <div class="p-fluid p-formgrid grid mt-3">
                    <div class="field col-12 md:col-3">
                        <label htmlFor="vehicle" class="text-sm text-500">{{
                            "VEHICLE_TO_COVER" | translate
                        }}</label>
                        <p-dropdown
                            *ngIf="selectedLanguage === 'en'"
                            id="vehicle"
                            (onChange)="onVehicleChange($event)"
                            [options]="vehicles"
                            optionLabel="registrationNumber"
                            optionValue="id"
                            placeholder="Select vehicle to cover"
                            formControlName="vehicleId"
                        ></p-dropdown>
                        <p-dropdown
                            *ngIf="selectedLanguage === 'pt'"
                            id="vehicle"
                            [options]="vehicles"
                            (onChange)="onVehicleChange($event)"
                            optionLabel="registrationNumber"
                            optionValue="id"
                            placeholder="Viatura a cobrir"
                            formControlName="vehicleId"
                        ></p-dropdown>
                    </div>
                    <div class="field col-12 md:col-3">
                        <label
                            htmlFor="insuranceType"
                            class="text-sm text-500"
                            >{{ "INSURANCE_TYPE" | translate }}</label
                        >
                        <p-dropdown
                            *ngIf="selectedLanguage === 'en'"
                            id="insuranceType"
                            [options]="insuranceTypes"
                            optionLabel="description"
                            optionValue="name"
                            (onChange)="onInsuranceTypeChange($event)"
                            placeholder="Select insurance type"
                            formControlName="insuranceType"
                        ></p-dropdown>
                        <p-dropdown
                            *ngIf="selectedLanguage === 'pt'"
                            id="insuranceType"
                            [options]="translatedInsuranceTypes"
                            optionLabel="description"
                            optionValue="name"
                            (onChange)="onInsuranceTypeChange($event)"
                            placeholder="Tipo de seguro"
                            formControlName="insuranceType"
                        ></p-dropdown>
                    </div>

                    <div
                        class="field col-12 md:col-3"
                        *ngIf="paymentFrequencies"
                    >
                        <label
                            htmlFor="paymentFrequency"
                            class="text-sm text-500"
                            >{{
                                "PREFERRED_PAYMENT_FREQUENCY" | translate
                            }}</label
                        >
                        <p-dropdown
                            #paymentDropdownEn
                            *ngIf="selectedLanguage === 'en'"
                            id="paymentFrequency"
                            [options]="paymentFrequencies"
                            (onChange)="onPaymentFrequencyChange($event)"
                            formControlName="paymentFrequency"
                            optionLabel="description"
                            optionValue="name"
                            placeholder="Select Preferred Payment Frequency"
                        ></p-dropdown>
                        <p-dropdown
                            *ngIf="selectedLanguage === 'pt'"
                            id="paymentFrequency"
                            #paymentDropdownPt
                            formControlName="paymentFrequency"
                            (onChange)="onPaymentFrequencyChange($event)"
                            [options]="translatedPaymentFrequencies"
                            optionLabel="description"
                            optionValue="name"
                            placeholder="Frequência de pagamento"
                        ></p-dropdown>
                    </div>
                </div>
                <div class="align-items-right">
                    <div
                        class="flex gap-2 mt-1"
                        *ngIf="
                            getDeviceType() === 'desktop' ||
                            getDeviceType() === 'tablet'
                        "
                    >
                        <button
                            icon="pi pi-times"
                            pRipple
                            pButton
                            (click)="clearForm()"
                            [label]="'Clear' | translate"
                            style="
                                background-color: #737373;
                                border: none;
                                outline: none;
                            "
                        ></button>
                        <button
                            icon="pi pi-check-circle"
                            [label]="'Options' | translate"
                            severity="secondary"
                            [disabled]="!quotationsForm.valid"
                            pTooltip="View available options"
                            pButton
                            pRipple
                            (click)="generateOptions()"
                        ></button>
                        <button
                            *ngIf="cartItemsCount > 0"
                            (click)="goToCart()"
                            icon="pi pi-shopping-cart"
                            [label]="'GO_TO_CART' | translate"
                            style="
                                background-color: green;
                                border: none;
                                outline: none;
                            "
                            pButton
                            pRipple
                        ></button>
                    </div>
                    <div
                        class="flex flex-column gap-3 mt-4 px-4"
                        *ngIf="getDeviceType() === 'mobile'"
                    >
                        <button
                            pRipple
                            pButton
                            (click)="clearForm()"
                            [label]="'Clear' | translate"
                            style="
                                background-color: #737373;
                                border: none;
                                outline: none;
                            "
                        ></button>
                        <button
                            [label]="'Options' | translate"
                            severity="primary"
                            [disabled]="!quotationsForm.valid"
                            pTooltip="View available options"
                            pButton
                            pRipple
                            (click)="generateOptions()"
                        ></button>

                        <button
                            *ngIf="cartItemsCount > 0"
                            (click)="goToCart()"
                            [label]="'GO_TO_CART' | translate"
                            style="
                                background-color: #419f3d;
                                border: none;
                                outline: none;
                            "
                            pButton
                            pRipple
                        ></button>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <div class="col-12 xl:col-12 p-0" *ngIf="hasOptions()">
        <div class="py-4">
            <p-messages [(value)]="messages" [closable]="true" />
            <div class="options-container">
                <h5 style="color: gray" class="ml-1 mb-0">
                    {{ "Available Options" | translate }}
                </h5>
                <small class="list-stats ml-1">
                    {{ "Pick an option" | translate }}</small
                >
                <div class="mt-3">
                    <app-insurance-option-card
                        (removeInsuranceOption)="
                            onRemoveInsuranceOptionFromList($event)
                        "
                        (addToCart)="addToCart($event)"
                        [canBeAddedToCart]="canBeAddedToCart"
                        [insuranceOption]="option"
                        *ngFor="let option of motorCoverOptions"
                    ></app-insurance-option-card>
                </div>
            </div>
            <!-- <app-insurance-options-carousel [slides]="motorCoverOptions"></app-insurance-options-carousel> -->
            <!-- <p-table
                *ngIf="(getDeviceType()==='desktop' || getDeviceType()==='tablet')"
                [value]="motorCoverOptions"
                [paginator]="true"
                [rows]="20"
                responsiveLayout="scroll"
            >
                <ng-template pTemplate="header">
                    <tr>
                        <th>{{ "PROVIDER" | translate }}</th>
                        <th>{{ "PACKAGE" | translate }}</th>
                        <th>{{ "VEHICLE_VALUE" | translate }}</th>
                        <th>{{ "ANNUAL_PREMIUM" | translate }}</th>
                        <th>{{ "PREMIUM_DUE" | translate }}</th>
                        <th>{{ "ACTIONS" | translate }}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-option>
                    <tr>
                        <td>
                            <span class="p-column-title">Provider</span>
                            {{ option.providerName }}
                        </td>
                        <td>
                            <span class="p-column-title">Package</span>
                            {{ option.packageName }}
                        </td>

                        <td>
                            <span class="p-column-title">Vehicle Value</span>
                            {{ option.insurableValue | currency : "MZN" + " " }}
                        </td>
                        <td>
                            <span class="p-column-title">Annual Premium</span>
                            {{ option.annualPremium | currency : "MZN" + " " }}
                        </td>
                        <td>
                            <span class="p-column-title">Premium Due</span>
                            {{ option.premiumDue | currency : "MZN" + " " }}
                        </td>

                        <td>
                            <p-button
                                [pTooltip]="
                                    'ADD_OPTION_TO_CART_TOOLTIP' | translate
                                "
                                *ngIf="canBeAddedToCart; else notAddedToCart"
                                icon="pi pi-cart-plus"
                                [rounded]="true"
                                [text]="true"
                                (onClick)="addToCart(option)"
                                severity="success"
                            />
                            <ng-template #notAddedToCart>
                                <span class="mx-3" pTooltip="Upload all vehicle documents first.">
                                <p-button icon="pi pi-cart-plus"
                                          [rounded]="true"
                                          [disabled]="true"
                                          [text]="true"
                                          (onClick)="addToCart(option)"
                                          severity="success">

                            </p-button>
                            </span>
                            </ng-template>
                        </td>
                    </tr>
                </ng-template>
            </p-table> -->
            <!-- <div *ngIf="getDeviceType()=='mobile'">
                <app-insurance-option-card (click)="addToCart(option)" [insuranceOption]="option"
                                           *ngFor="let option of motorCoverOptions"></app-insurance-option-card>
            </div> -->
        </div>
    </div>
    <p-divider class="w-full mt-2" *ngIf="!hasOptions()"></p-divider>
    <div class="col-12 xl:col-12" *ngIf="!hasOptions()">
        <div class="w-full">
            <div
                class="cart-container flex flex-column align-items-center justify-content-center"
            >
                <img
                    class="w-5rem h-5rem"
                    src="../../../../assets/demo/images/no_options.gif"
                />
                <span class="text-md mt-4 mb-2 zero-options">{{
                    "Fill in the form above and click 'Options' to view available options here."
                        | translate
                }}</span>
            </div>
        </div>
    </div>
</div>
